const Utility = {
    get_permission_editable_with_key(key){
        return JSON.parse(localStorage.getItem('user_profile'))['permission'][key] >= 2
    }
}
export default Utility